var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90258 15.7208C6.90258 14.4695 7.13069 13.2304 7.57389 12.0743C8.01709 10.9183 8.66669 9.86783 9.48561 8.98302C10.3045 8.0982 11.2767 7.39632 12.3467 6.91746C13.4167 6.4386 14.5635 6.19214 15.7216 6.19214C16.8797 6.19214 18.0265 6.4386 19.0965 6.91746C20.1665 7.39632 21.1387 8.0982 21.9576 8.98302C22.7765 9.86783 23.4261 10.9183 23.8693 12.0743C24.3125 13.2304 24.5406 14.4695 24.5406 15.7208V15.7208C24.5406 20.4718 25.4618 23.2322 26.2725 24.7451C26.3586 24.9063 26.404 25.089 26.4041 25.2751C26.4043 25.4611 26.3592 25.6439 26.2733 25.8052C26.1875 25.9665 26.064 26.1006 25.9151 26.194C25.7662 26.2875 25.5972 26.337 25.425 26.3377H6.01822C5.84603 26.337 5.67702 26.2875 5.52812 26.194C5.37923 26.1006 5.25568 25.9665 5.16984 25.8052C5.08401 25.6439 5.03891 25.4611 5.03906 25.2751C5.03922 25.089 5.08461 24.9063 5.17071 24.7451C5.98137 23.2322 6.90258 20.4718 6.90258 15.7208Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7914 26.3376V27.3993C11.7914 28.5256 12.2055 29.6058 12.9427 30.4022C13.6798 31.1987 14.6795 31.6461 15.7219 31.6461C16.7644 31.6461 17.7641 31.1987 18.5012 30.4022C19.2383 29.6058 19.6524 28.5256 19.6524 27.3993V26.3376",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5266 4.04224C24.5273 5.40679 26.142 7.33968 27.1941 9.62937",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24963 9.62937C5.30168 7.33968 6.9164 5.40679 8.91708 4.04224",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.5f577749b45c9f32eb2fbd3512cd45ad.svg";
export { ForwardRef as ReactComponent };